export const crowBeeldkwaliteitSelectOptions = {
    crowScore: [
        { value: 'A+', text: 'A+' },
        { value: 'A', text: 'A' },
        { value: 'B', text: 'B' },
        { value: 'C', text: 'C' },
        { value: 'D', text: 'D' },
        { value: 'NVT', text: 'Niet van toepassing' },
    ],
};
